import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  addNewLeadApi,
  getClientDataApi,
  resendOtpApi,
  verifyOtpApi,
} from "services/leadServices";
import { clientDataFetchedSuccessful } from "./reducer";

export const addNewLead = createAsyncThunk(
  "crm/addNewLead",
  async (lead: any) => {
    try {
      const response = addNewLeadApi(lead);
      return response;
    } catch (error: any) {
      toast.error(error?.message, { autoClose: 3000 });
      // toast.error("Lead Added Failed", { autoClose: 3000 });
      return error;
    }
  }
);

export const verifyOtp = createAsyncThunk("otp/verify", async (Otp: any) => {
  try {
    console.log("otp api", Otp);
    const response = verifyOtpApi(Otp);
    return response;
  } catch (error: any) {
    toast.error(error?.message, { autoClose: 3000 });
    return error;
  }
});
export const resendOtp = createAsyncThunk("otp/resend", async (Otp: any) => {
  try {
    console.log("otp api", Otp);
    const response = resendOtpApi(Otp);
    return response;
  } catch (error: any) {
    toast.error(error?.message, { autoClose: 3000 });
    return error;
  }
});


export const getClientData = (subdomain: string) => async (dispatch: any) => {
  try {
    const params = { subdomain };

    const response = await getClientDataApi(params);

    if (response.success) {
      dispatch(clientDataFetchedSuccessful({ clientData: response.data }));
    }
  } catch (getClientError: any) {
    const errorMessage =
      getClientError?.message ||
      getClientError?.response?.data?.message ||
      "Something went wrong";
    // dispatch(clientDataFetchedError(errorMessage))
  }
};
